// extracted by mini-css-extract-plugin
export default {"main":"Workflow_main__DGCm+","h1":"Workflow_h1__F2aN1","span":"Workflow_span__0iWSG","h11":"Workflow_h11__d8Bmo"};